<template>
  <b-modal id="modalExperiment" ref="modalExperiment"
    :hide-footer="true"
    class="experiment_modal"
    :visible="true"
    @hidden="$emit('hidden')">
    <template v-if="errors.length || duplicates.length">
      <h2 class="text--white mb-3 text-center px-4">Upss..</h2>
      <ul>
        <li v-for="(error, index) in errors" :key="index">
          {{ `Well ${wellPosition(error.x_position, error.y_position)}
            ${$t("buildingBlocks.error")}` }}
        </li>
        <li v-for="(duplicate, index) in duplicates" :key="index">
          {{ `Well ${wellPosition(duplicate.x_position, duplicate.y_position)}
            ${$t("buildingBlocks.duplicate")}` }}
        </li>
      </ul>
    </template>
    <template v-if="!errors.length">
      <h2 class="text--white mb-3 mt-4 text-center px-4">
        {{ $t("buildingBlocks.enterTitle") }}
      </h2>
      <b-form @submit.prevent="submit">
        <b-form-input
          v-model="experiment.title"
          required placeholder="Name field..."
          class="mb-3">
        </b-form-input>
        <div class="d-flex justify-content-center mt-4">
          <b-btn variant="secondary" size="sm" class="mr-4 mt-0" type="submit">
            {{ $t("save") }}</b-btn>
          <b-btn variant="secondary" size="sm" class="mt-0" @click="$emit('hidden')">
            {{ $t("cancel") }}</b-btn>
        </div>
      </b-form>
    </template>
  </b-modal>
</template>

<script>

export default {
  props: ['errors', 'duplicates', 'title'],
  data() {
    return {
      experiment: {
        title: '',
      },
    };
  },
  methods: {
    submit() {
      this.$emit('submit', this.experiment.title);
    },
    wellPosition(x, y) {
      return String.fromCharCode(97 + y).toUpperCase() + (x + 1);
    },
  },
  created() {
    this.experiment.title = this.title;
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Game/BuldingBlocks/Board/CreateExperimentModal.vue